import SEOLandingTemplate from './SEOLandingTemplate';

export default function MetaTagGeneratorPage() {
  return (
    <SEOLandingTemplate
      title="Meta Tag Generator"
      metaTitle="Free Meta Tag Generator | Sungresh"
      metaDescription="Generate SEO title tags and meta descriptions with length guidance and a Google search-result preview."
      h1="Free Meta Tag Generator"
      sub="Generate a title tag and meta description for your page, with live character counts and a preview of how they'll look in a Google search result."
      keywords="meta tag generator, meta description generator, title tag generator"
      ctaLink="/checker"
      ctaText="Generate Meta Tags Free"
      features={[
        { icon: '🏷️', title: 'Title Tag', desc: 'Guidance toward the ~50-60 character range Google typically displays in full' },
        { icon: '📝', title: 'Meta Description', desc: 'Guidance toward the ~150-160 character range' },
        { icon: '👁️', title: 'SERP Preview', desc: 'See roughly how it will look in Google search results' },
        { icon: '📏', title: 'Live Length Check', desc: 'Character count updates as you type' },
      ]}
      faqs={[
        { q: 'How long should a title tag be?', a: 'Roughly 50-60 characters. Google truncates longer titles in search results, though the exact cutoff varies by device and pixel width, not just character count.' },
        { q: 'How long should a meta description be?', a: 'Roughly 150-160 characters is a safe target, though Google sometimes rewrites your description entirely if it thinks a different snippet answers the search better.' },
        { q: 'Do meta keywords tags still matter?', a: 'Google has not used the meta keywords tag as a ranking signal for a long time. Focus your effort on the title tag and meta description instead.' },
      ]}
    />
  );
}
